import { render, staticRenderFns } from "./BodyHistorique.vue?vue&type=template&id=02edb77e&scoped=true"
import script from "./BodyHistorique.vue?vue&type=script&lang=js"
export * from "./BodyHistorique.vue?vue&type=script&lang=js"
import style0 from "./BodyHistorique.vue?vue&type=style&index=0&id=02edb77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02edb77e",
  null
  
)

export default component.exports